import {Vec2} from "../../../../../Utils/ThreeJS/VectorStructs.js";

/** V3: spot-height terrain modifier (§5.3.3 of Features/Set5.md).
 *
 *  Spot heights are point-shaped terrain features (a single elevation pin at a `MapObject`'s
 *  anchor position, optionally a small disk of cells). They live as a Modifier on `MapObject`
 *  (not on `ObjPath`) because they don't have path geometry.
 *
 *  At solve-prep time, the engine walks all `MapObject`s for this modifier and converts each
 *  into a Dirichlet disk cell set. */

export class Mod_TerrainSpotHeight {
	constructor(data?: Partial<Mod_TerrainSpotHeight>) { Object.assign(this, data); }

	/** Target elevation (meters above sea level, world frame). */
	elevation = 0;
	/** Pin radius (meters): cells within this radius of the MapObject's anchor point are
	 *  pinned at `elevation`. Default 0.5 = single-cell pin. */
	radius = 0.5;
	/** World-position offset (metres) added to the parent `MapObject`'s anchor position before
	 *  rasterizing the spot-height disk. Rotation is NOT applied (consistent with `ObjPath`
	 *  geometry, which is also currently rotation-unaware). Mirrors `MapObject.label_offset`. */
	offset: Vec2|n;
}
